import { CameraData } from "../../camera/interfaces/dto";

export function buildCameraOutput(
	camera: CameraData,
	wrapper: HTMLElement,
	gridItemToClone: HTMLElement,
) {
	const item = gridItemToClone.cloneNode(true) as HTMLElement;

	const imageLink: HTMLAnchorElement | null = item.querySelector(
		".card-item-header",
	);

	if (imageLink && imageLink.tagName.toLowerCase() === "a") {
		imageLink.href = camera.url;
		imageLink.style.backgroundImage = "url(" + camera.latestPhotoUrl + ")";
	}

	const cameraNameEl: HTMLElement | null =
		item.querySelector(".camera-name");

	if (cameraNameEl) {
		cameraNameEl.textContent = camera.aliasedName;
	}

	const photosCountEl = item.querySelector(".photos-count") as HTMLElement;

	if (photosCountEl) {
		photosCountEl.textContent = camera.totalPhotos.toString();
	}

	const viewPhotosLink = item.querySelector(
		".view-photos-link",
	) as HTMLAnchorElement;

	if (viewPhotosLink) {
		viewPhotosLink.href = camera.url;
	}

	wrapper.appendChild(item);
}
